import { Link, TextStyle } from '@superops/ui-design-system';
import React from 'react';

function LinkCell(props) {
  const { cell } = props;
  const { actions = {} } = cell.column;
  return cell.value ? (
    <div title={cell.value} className="ellipsis mr10">
      <Link
        removeUnderline
        onClick={actions.onClick?.bind(this, cell)}
        fontWeight="normal"
      >
        {cell.value}
      </Link>
    </div>
  ) : (
    <TextStyle disabled>NA</TextStyle>
  );
}

export default LinkCell;
